import store from '@/store'

export default (value) => {
  if (!value || typeof value !== 'string') return value

  const regexValue = store.getters.ecosystemConfig?.cleanEntityPrefixRegex
  if (regexValue) {
    try {
      const regex = new RegExp(regexValue, 'g')
      return value.replace(regex, '')
    } catch (e) {
      console.error('Invalid cleanEntityPrefixRegex:', regexValue, e)
      return value
    }
  }
  return value
}
